/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { Navigate, useParams } from 'react-router';

/* Import configuration */
import { APP_ROUTES } from '@/config/appRoutes';
import { OVERVIEW_ANOMALY_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import AnomalyMetricsOverview from '@/components/tabs/overview/metrics/AnomalyMetricsOverview';

/* Import libraries */
import {
    OVERVIEW_STATUS_CATEGORIES,
    type OverviewStatusCategory,
} from '@/lib/overview/overviewCards';

const STATUS_LABELS: Record<OverviewStatusCategory, string> = {
    danger: 'Error',
    success: 'OK',
    warning: 'Warning',
};

function isOverviewStatusCategory(value: string): value is OverviewStatusCategory {
    return OVERVIEW_STATUS_CATEGORIES.includes(value as OverviewStatusCategory);
}

function StatusDetailTab() {
    const { statusKey } = useParams<{ statusKey: string }>();

    if (!statusKey || !isOverviewStatusCategory(statusKey)) {
        return <Navigate to={APP_ROUTES.statuses} replace />;
    }

    return (
        <AnomalyMetricsOverview
            anomalyConfigs={OVERVIEW_ANOMALY_CONFIGS}
            description="Overview of all available anomaly metrics."
            fixedStatus={statusKey}
            heading={STATUS_LABELS[statusKey]}
            idPrefix="status-detail"
        />
    );
}

export default StatusDetailTab;
